import { render, staticRenderFns } from "./product-summary-travel-insurance-card.vue?vue&type=template&id=0e8755c5&scoped=true"
import script from "./product-summary-travel-insurance-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./product-summary-travel-insurance-card.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./product-summary-travel-insurance-card.vue?vue&type=style&index=0&id=0e8755c5&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8755c5",
  null
  
)

export default component.exports